const faqsContentParagraph = document.querySelectorAll("#faqs_categories p");

function replaceNbsps(str) {
    var re = new RegExp(String.fromCharCode(10), "g");
    return str.trim().replace(re, "<br>");
}

faqsContentParagraph.forEach( (paragraph) => {
    paragraph.innerHTML = replaceNbsps(paragraph.innerHTML);
});

window.onload = function() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    const categoryId = params.category;
    const questionId = params.q;
    if (questionId && categoryId) {
        document.querySelector("#faq_category_" + categoryId + " button") && document.querySelector("#faq_category_" + categoryId + " button").classList.remove("collapsed");
        document.querySelector("#faq_category_" + categoryId +"_answer") && document.querySelector("#faq_category_" + categoryId +"_answer").classList.add("show");
        document.querySelector("#faq_q_" + questionId + " button") && document.querySelector("#faq_q_" + questionId + " button").classList.remove("collapsed");
        document.querySelector("#faq_q_" + questionId +"_answer") && document.querySelector("#faq_q_" + questionId +"_answer").classList.add("show");
    }
}